<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0">Profissionais</h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item fw-semibold">Profissionais</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-content>
    <div class="d-flex">
      <div class="tagus-form-group w-100">
        <mat-form-field appearance="fill">
          <i class="ri-search-line"></i>
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="applyFilter($event)" #input />
        </mat-form-field>
      </div>
      <div>
        <button mat-icon-button (click)="getAll()">
          <mat-icon>update</mat-icon>
        </button>
      </div>
    </div>
    <div class="mat-elevation-z8 tagus-mat-table">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="licenseNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº Licença</th>
          <td mat-cell *matCellDef="let element">
            {{ element.licenseNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Termo de Subscrição</th>
          <td mat-cell *matCellDef="let element">

            <div>
              <mat-chip
                [class.custom-chip-green]="element?.contractFile?.status === 'APPROVED'"
                [class.custom-chip-red]="element?.contractFile?.status === 'REJECTED'"
                [class.custom-chip-warning]="element?.contractFile?.status === 'PENDING_UPLOAD'"

              >
                <i
                  class="ri-check-line"
                  *ngIf="element?.contractFile?.status === 'APPROVED'"
                ></i>
                <i
                  class="ri-file-excel-line"
                  *ngIf="element?.contractFile?.status === 'REJECTED'"
                ></i>
                {{ getNameStatus(element?.contractFile?.status) }}
              </mat-chip>
            </div>
            <button
              type="button"
              mat-button
              class="position-relative dot-btn p-0 bg-transparent border-none"
              [matMenuTriggerFor]="monthMenu"
            >
              <i class="ri-more-fill"></i>
            </button>
            <mat-menu
              #monthMenu="matMenu"
              class="dotMenu monthMenu"
              xPosition="before"
            >
              <button
                (click)="viewFileDialog(element?.contractFile?._id, element?.contractFile?.mimetype, element.id)"
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
              >
                <i class="ri-eye-line"></i> Visualizar
              </button>
              <button
                (click)="checkFile(element?.contractFile?._id, 'APPROVED')"
                mat-menu-item
                type="button"
                class="bg-transparent border-nonbuttononon-relative"
              >
                <i class="ri-checkbox-line"></i> Aceitar
              </button>

              <button
                (click)="checkFile(element?.contractFile?._id, 'REJECTED')"
                mat-menu-item
                type="button"
                class="bg-transparent border-nonbuttononon-relative"
              >
                <i class="ri-file-excel-line"></i> Rejeitar
              </button>
              <button
                (click)="
                  downloadFile(
                    element?.contractFile?._id,
                    element?.contractFile?.mimetype,
                    element?.contractFile?.name,
                    element.name
                  )
                "
                mat-menu-item
                type="button"
                class="bg-transparent border-nonbuttononon-relative"
              >
                <i class="ri-download-2-fill"></i> Baixar
              </button>
              <button
                (click)="
                  openDialog(
                    element?.contractFile?._id,
                    element?.contractFile?.fieldname,
                    element?.contractFile?.description,
                    element?.contractFile?.name,
                    element.id
                  )
                "
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
              >
                <i class="ri-edit-line"></i> Editar
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Não foram encontradas informações.
          </td>
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
